import { useState } from 'react';
import { useReduxState } from 'hooks';
import { useApiData } from 'lib/api';
import {
  EmptyIndicator,
  LoadingIndicator,
  Pagination
} from 'components/common';
import { PageSection, PageSectionHeader } from 'components/page';
import {
  AnalyticsCoursesCategoryFilter,
  AnalyticsCoursesListCourse,
  AnalyticsGroupFilter
} from '.';

import type { PageState } from 'types';

export type AnalyticsCourse = PageState['course'] & {
  stats: {
    allParticipants: number;
    allParticipantsCompleted: number;
    allParticipantsCompletionExpired: number;
    allParticipantsCompletionExpiring: number;
    allParticipantsNotStarted: number;
    allParticipantsStarted: number;
    currentParticipants: number;
    currentParticipantsCompleted: number;
    currentParticipantsCompletionExpired: number;
    currentParticipantsCompletionExpiring: number;
    currentParticipantsNotStarted: number;
    currentParticipantsStarted: number;
  };
};

const AnalyticsCoursesList = () => {
  const { messages, user } = useReduxState();

  const [categoryId, setCategoryId] = useState(0);
  const [groupId, setGroupId] = useState(0);
  const [page, setPage] = useState(1);

  const { loading, data } = useApiData({
    url:
      `/admin/analytics/courses?page=${page}` +
      (categoryId ? `&categoryId=${categoryId}` : '') +
      (groupId ? `&groupId=${groupId}` : '')
  });

  const filterCategory = (categoryId: number) => {
    setCategoryId(categoryId);
    setPage(1);
  };

  const filterGroups = (groupId: number) => {
    setGroupId(groupId);
    setPage(1);
  };

  return (
    <PageSection>
      <PageSectionHeader
        description={
          user?.roles?.includes('superadmin')
            ? messages.analyticsCoursesDescriptionSuperadmin
            : messages.analyticsCoursesDescriptionAdmin
        }
        title={messages.commonCourses}
      >
        <div style={{ display: 'flex' }}>
          <div style={{ marginRight: 15 }}>
            <AnalyticsCoursesCategoryFilter getCategoryId={filterCategory} />
          </div>
          <div>
            <AnalyticsGroupFilter getGroupId={filterGroups} />
          </div>
        </div>
      </PageSectionHeader>

      {loading ? (
        <LoadingIndicator />
      ) : data?.courses?.length ? (
        <div className="list">
          {data.courses.map((course) => (
            <AnalyticsCoursesListCourse key={course.id} course={course} />
          ))}

          <Pagination
            currentPage={page}
            numberOfPages={data?.pages || 1}
            onPageChange={({ page }) => setPage(page)}
          />
        </div>
      ) : (
        <EmptyIndicator icon="book" title={messages.coursesNoCoursesFound} />
      )}
    </PageSection>
  );
};

export default AnalyticsCoursesList;
